import { Component, OnInit } from '@angular/core';
import {
  IAgenda,
  ICollection,
  IColors,
  ICustomApp,
  IEventGeneralSettings,
  IKeynote,
  INavigation,
  INavigationLink,
  INetworking,
  IReception,
  ITradeFair,
  IWorkshop,
  NavigationLinkType
} from '@sv/interfaces';
import { KeynoteService } from '../../../_services/_content/keynote.service';
import { Router } from '@angular/router';
import { ReceptionService } from '../../../_services/_content/reception.service';
import { WorkshopService } from '../../../_services/_content/workshop.service';
import { NetworkingService } from '../../../_services/_content/networking.service';
import { CustomAppService } from '../../../_services/_content/customApp.service';
import { TradefairService } from 'src/app/_services/_content/_TradeFair/tradefair.service';
import { NavigationService } from 'src/app/_services/_content/navigation.service';
import { GeneralSettingsService } from 'src/app/_services/_content/general-settings.service';
import { AgendaService } from 'src/app/_services/_content/agenda.service';
import { EventAnalyticsService } from 'src/app/_services/_analytics/event-analytics.service';
import { customApp } from 'src/app/_configuration/configuration';
import { FormControl } from '@angular/forms';
import { delay } from 'rxjs/operators';
import { AuthService } from 'src/app/_services/_auth/auth.service';
import { CollectionService } from 'src/app/_services/_content/collection.service';
@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit {
  customApp: ICustomApp;
  generalSettings: IEventGeneralSettings;
  navigation: INavigation;
  links: INavigationLink[];
  agenda: IAgenda;

  NavigationLinkType = NavigationLinkType;

  showAgenda = false;
  showDownloads = false;
  showSupport = false;
  submenu = false;
  loaded = false;

  moreIconPositon: string;

  imgColor: string;

  catchAllRoute: NavigationLinkType;

  colors: IColors;

  constructor(
    private keynoteService: KeynoteService,
    private receptionService: ReceptionService,
    private workshopService: WorkshopService,
    private networkingService: NetworkingService,
    private router: Router,
    private customAppService: CustomAppService,
    private fairService: TradefairService,
    private navigationService: NavigationService,
    private generalSettingService: GeneralSettingsService,
    private agendaService: AgendaService,
    private eventAnalyticsService: EventAnalyticsService,
    private authService: AuthService,
    private collectionService: CollectionService
  ) {}

  expo = false;
  collection = false;
  booth = false;
  searching = false;
  searchValue = new FormControl('');
  searchText = 'Search Booths';

  ngOnInit() {
    this.searchValue.valueChanges.subscribe((val) => {
      val = val.length === 0 ? null : val;
      this.customAppService.pushNewSearchValue(val);
    });

    this.customAppService.getCustomAppListener().subscribe(async (app) => {
      this.customApp = app;
      if (typeof this.customApp.navigation === 'string') {
        this.navigation = await this.navigationService.getCompleteNavigationById(this.customApp.navigation);
      } else {
        this.navigation = this.customApp.navigation;
      }

      this.navigation.impressumText = this.navigation.impressumText ?? 'Impressum';
      this.navigation.impressumLink = this.navigation.impressumLink ?? 'https://streavent.de/impressum/';
      this.links = this.navigation.links as INavigationLink[];
      this.colors = this.customApp.colors as IColors;
      // If page is reloaded with an active component we have to make sure the selected keynote matches the service
      this.prepopulateContentServices();

      this.loaded = true;

      if (typeof this.customApp.generalSettings === 'string') {
        this.generalSettings = await this.generalSettingService.getGeneralSettings(this.customApp.generalSettings);
      } else {
        this.generalSettings = this.customApp.generalSettings;
      }

      if (typeof this.customApp.agenda === 'string') {
        this.agenda = await this.agendaService.getAgendaById(this.customApp.agenda);
      } else {
        this.agenda = this.customApp.agenda;
      }

      this.customAppService.getExpoActive().subscribe(async (val) => {
        // otherwise expresion has changed error on dev
        await delay(0);
        if (val) {
          this.expo = true;
          this.searchText = val;
        } else {
          this.expo = false;
        }

        this.searchValue.setValue('');
        this.searching = false;
      });
      this.customAppService.getBoothActive().subscribe(async (val) => {
        // otherwise expresion has changed error on dev
        await delay(0);
        this.booth = val;
      });
      this.customAppService.getCollectionActive().subscribe(async (val) => {
        // otherwise expression has changed error on dev
        await delay(0);
        if (val) {
          this.collection = true;
          this.searchText = val;
        } else {
          this.collection = false;
        }

        this.searchValue.setValue('');
        this.searching = false;
      });
    });
  }

  prepopulateContentServices() {
    const path = location.pathname;
    const roomIdPath = path.split('/')[2];

    // prepoulate collection room if reload on collection room
    if (roomIdPath) {
      const collectionLink = this.links.find((link) => link.route === path.split('/')[1]);
      if (collectionLink) {
        const collection = collectionLink.collectionSettings as ICollection;
        if (roomIdPath) {
          for (const room of collection.rooms) {
            if ((room.expoId as ITradeFair)?._id === roomIdPath) {
              this.fairService.setFair(room.expoId);
              break;
            } else if ((room.keynoteId as IKeynote)?._id === roomIdPath) {
              this.keynoteService.setKeynote(room.keynoteId);
            } else if ((room.networkingId as INetworking)?._id === roomIdPath) {
              this.networkingService.setNetworking(room.networkingId);
            } else if ((room.workshopId as IWorkshop)?._id === roomIdPath) {
              this.workshopService.setWorkshop(room.workshopId);
            } else if ((room.receptionId as IReception)?._id === roomIdPath) {
              this.receptionService.setReception(room.receptionId);
            } else if ((room.collectionId as ICollection)?._id === roomIdPath) {
              this.collectionService.setCollection(room.collectionId);
            }
          }
          this.collectionService.setCollection(collection);
        }
      }
    }

    for (const link of this.links) {
      if (path === '/') {
        if (link) {
          switch (this.catchAllRoute) {
            case NavigationLinkType.Reception:
              this.receptionService.setReception(link.receptionSettings);
              break;
            case NavigationLinkType.Keynote:
              this.keynoteService.setKeynote(link.keynoteSettings);
              break;
            case NavigationLinkType.Workshop:
              this.workshopService.setWorkshop(link.workshopSettings);
              break;
            case NavigationLinkType.Networking:
              this.networkingService.setNetworking(link.networkingSettings);
              break;
            case NavigationLinkType.Fair:
              this.fairService.setFair(link.fairSettings);
              break;
            case NavigationLinkType.Collection:
              this.collectionService.setCollection(link.collectionSettings);
              break;
          }
          this.router.navigate(['/']);
        }
        return;
      }

      if ('/' + link.route === path) {
        switch (link.type) {
          case NavigationLinkType.Reception:
            this.receptionService.setReception(link.receptionSettings);
            break;
          case NavigationLinkType.Keynote:
            this.keynoteService.setKeynote(link.keynoteSettings);
            break;
          case NavigationLinkType.Workshop:
            this.workshopService.setWorkshop(link.workshopSettings);
            break;
          case NavigationLinkType.Networking:
            this.networkingService.setNetworking(link.networkingSettings);
            break;
          case NavigationLinkType.Fair:
            this.fairService.setFair(link.fairSettings);
            break;
          case NavigationLinkType.Collection:
            this.collectionService.setCollection(link.collectionSettings);
            break;
        }
        this.router.navigate([link.route]);
      }
    }
  }

  openDownloads() {
    this.showAgenda = false;
    this.showSupport = false;
    this.showDownloads = !this.showDownloads;
  }

  openAgenda() {
    this.showDownloads = false;
    this.showSupport = false;
    this.showAgenda = !this.showAgenda;
  }

  openSupport() {
    this.showAgenda = false;
    this.showDownloads = false;
    this.showSupport = !this.showSupport;
  }

  close() {
    this.showDownloads = false;
    this.showAgenda = false;
    this.showSupport = false;
  }

  async changeKeynote(link: INavigationLink) {
    await this.eventAnalyticsService.newLinkView();
    await this.eventAnalyticsService.startLinkDuration(link._id, customApp.eventId);
    this.keynoteService.setKeynote(link.keynoteSettings);
  }

  async loadReception(link: INavigationLink) {
    await this.eventAnalyticsService.newLinkView();
    await this.eventAnalyticsService.startLinkDuration(link._id, customApp.eventId);
    this.receptionService.setReception(link.receptionSettings);
  }

  async loadNetworking(link: INavigationLink) {
    await this.eventAnalyticsService.newLinkView();
    await this.eventAnalyticsService.startLinkDuration(link._id, customApp.eventId);
    this.networkingService.setNetworking(link.networkingSettings);
  }

  async loadWorkshop(link: INavigationLink) {
    await this.eventAnalyticsService.newLinkView();
    await this.eventAnalyticsService.startLinkDuration(link._id, customApp.eventId);
    this.workshopService.setWorkshop(link.workshopSettings);
  }

  async loadFair(link: INavigationLink) {
    await this.eventAnalyticsService.newLinkView();
    await this.eventAnalyticsService.startLinkDuration(link._id, customApp.eventId);

    this.fairService.setFair(link.fairSettings);
  }

  async loadCollection(link: INavigationLink) {
    await this.eventAnalyticsService.newLinkView();
    await this.eventAnalyticsService.startLinkDuration(link._id, customApp.eventId);

    this.collectionService.setCollection(link.collectionSettings);
  }

  isOverflown(element) {
    const difference = element.scrollHeight - element.clientHeight;
    if (difference > 20) {
      this.moreIconPositon = element.clientHeight - 100 + 'px';
      return true;
    }
  }

  toggleSubmenu() {
    this.submenu = !this.submenu;
  }

  closeSubmenu() {
    this.submenu = false;
  }

  logout() {
    this.authService.logout();
  }
}
